import "../../styles/all.css"
import "./project.css"
import projectwork from "../../img/our-work.png"
import { useTranslation } from "react-i18next";
function Project(){
          const { t, i18n } = useTranslation();

    return(
        <>
        <div className="project">
<div className="project">
      <div className="continer">
        <h4>{t('our_projects')}</h4>
        <h4>{t('projects_description')}</h4>
      </div>

      <div className="project_content">
        <div className="left">
          <div className="image">
            <img src={projectwork} alt={t('project_dashboard')} />
          </div>
        </div>

        <div className="right">
          <h2>{t('project_title')}</h2>
          <p>{t('project_desc1')}</p>
          <p>{t('project_desc2')}</p>
          <p>{t('project_desc3')}</p>
          <p>{t('project_desc4')}</p>
          <p>{t('project_desc5')}</p>
        </div>
      </div>
    </div>
 
        </div>
        </>
    )
}
export default Project